export default __webpack_public_path__ + "assets/img/056459cbdb236ce232994845d855f71c.svg";